import Head from "next/head"
import { useRouter } from "next/router"
import { IntlProvider } from "react-intl"
import { RecoilRoot } from "recoil"
import styled from "styled-components"
import GlobalStyle from "styles/index"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import { muiTheme } from "@rentspree/component-2023.theme.mui"
import { datadogRum } from '@datadog/browser-rum'
import getConfig from 'next/config'
import packageJson from "../../package.json"

const { publicRuntimeConfig: env = {} } = getConfig() || {}

if (
  typeof window !== "undefined" &&
  env.DATADOG_CLIENT_TOKEN &&
  env.DATADOG_APPLICATION_ID &&
  env.DATADOG_SITE
) {
  datadogRum.init({
    applicationId: env.DATADOG_APPLICATION_ID,
    clientToken: env.DATADOG_CLIENT_TOKEN,
    site: env.DATADOG_SITE,
    service: packageJson.name,
    env: env.ENVIRONMENT,
    version: env.DATADOG_VERSION,
    sessionSampleRate: parseInt(env.DATADOG_SAMPLE_RATE || "0", 10),
    sessionReplaySampleRate: parseInt(env.DATADOG_REPLAY_SAMPLE_RATE || "0", 10),
    traceSampleRate: parseInt(env.DATADOG_TRACE_SAMPLE_RATE || "0", 10),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
      { match: env.RENTSPREE_API_URL || "", propagatorTypes: ["b3", "b3multi", "tracecontext"] },
      { match: env.RENTSPREE_USER_API_URL || "", propagatorTypes: ["b3", "b3multi", "tracecontext"]},
    ],
    excludedActivityUrls: [
      /^https:\/\/api\.amplitude\.com/,
      /^https:\/\/analytics\.google\.com/,
      /^https:\/\/.*\.clarity\.ms\/collect/,
      /^https:\/\/settings\.luckyorange\.net/,
    ],
  })
}

const PoppinsFont = styled.div`
  * {
    font-family: "Poppins", sans-serif !important;
  }
  .fal,
  .far {
    font-size: 30px;
    font-family: "Font Awesome 5 Pro" !important;
  }

  button i {
    font-family: "Font Awesome 5 Pro" !important;
  }
`
export default function App({ Component, pageProps }) {
  const router = useRouter()
  const { partner } = router.query
  const theme = createTheme(muiTheme)

  return (
    <>
      <Head>
        <title>RentSpree Pre-login Tenant Screening</title>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Merriweather:400,700"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,600;1,400&display=swap"
          rel="stylesheet"
        />
        <link
          rel="shortcut icon"
          href="https://cdn.rentspree.com/static-files/favicon/rentspree.ico"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://cdn.rentspree.com/static-files/component-2023/design-tokens@1.9.9.css"
        />
        <link
          rel="stylesheet"
          href="https://cdn.rentspree.com/static-files/component-2023/css/design-tokens@2.2.2.css"
        />
      </Head>
      <GlobalStyle />
      <RecoilRoot>
        <IntlProvider locale="en" defaultLocale="en">
          <PoppinsFont>
            <ThemeProvider theme={theme}>
              <Component {...pageProps} />
            </ThemeProvider>
          </PoppinsFont>
        </IntlProvider>
      </RecoilRoot>
    </>
  )
}
